export enum Country {
  BENELUX = 'BENELUX',
  ITALY = 'IT',
  UNITED_KINGDOM = 'UK',
  SPAIN = 'ES',
}
